/* Precise decaf results are filtered by Shopify, never by a client-side page slice. */
(() => {
  const node = document.getElementById('dpk-search-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const normalize = value => config.aliases.includes(value.toLocaleLowerCase('pl').trim().replace(/ {2,}/g, ' '))
    ? config.query : value;
  const searchUrl = (value, form) => {
    const url = new URL(config.searchUrl, location.origin);
    if (form) url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', normalize(value));
    if (normalize(value) === config.query) url.searchParams.set('type', 'product');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  };
  const current = new URL(location.href);
  const query = current.searchParams.get('q');
  if (current.pathname === config.searchUrl && query && normalize(query) !== query) {
    current.searchParams.set('q', normalize(query));
    current.searchParams.set('type', 'product');
    current.searchParams.delete('page');
    location.replace(current.href);
    return;
  }
  if (query === config.query) document.title = document.title.split(config.query).join(config.label);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || new URL(form.action).pathname !== config.searchUrl) return;
    const field = form.querySelector('[name="q"]');
    if (field && normalize(field.value) !== field.value) {
      event.preventDefault();
      location.assign(searchUrl(field.value, form).href);
    }
  }, true);

  // The existing asset incorrectly defines model-element instead of search-drawer.
  if (customElements.get('search-drawer')) return;
  customElements.define('search-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('[name="q"]');
      this.form = this.querySelector('form');
      this.trigger = this.querySelector('[rel="toggle-search"]');
      this.closeButton = this.querySelector('.wt-header__search__close');
      this.results = this.querySelector('[data-predictive-search]');
      this.top = this.querySelector('.predictive-search-status');
      if (!this.input || !this.results) return;
      this.status = document.createElement('span');
      this.status.className = 'visually-hidden';
      this.status.setAttribute('role', 'status');
      this.status.setAttribute('aria-live', 'polite');
      this.append(this.status);
      // Results contain native links. Do not promise listbox selection semantics.
      this.input.removeAttribute('role');
      this.input.removeAttribute('aria-owns');
      this.input.removeAttribute('aria-haspopup');
      this.trigger.addEventListener('click', () => this.open());
      this.input.addEventListener('focus', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.input.addEventListener('input', event => {
        this.cancel();
        this.results.replaceChildren();
        this.removeAttribute('results');
        this.status.textContent = '';
        if (event.isComposing) return;
        if (!this.input.value.trim()) { this.top.removeAttribute('aria-hidden'); return; }
        this.timer = setTimeout(() => this.load(), 220);
      });
      this.input.addEventListener('compositionend', () => {
        this.cancel();
        this.timer = setTimeout(() => this.load(), 220);
      });
      this.addEventListener('keydown', event => this.keyboard(event));
    }
    cancel() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.requestId = (this.requestId || 0) + 1;
      this.removeAttribute('loading');
    }
    open() {
      if (this.classList.contains('wt-drawer-search--active')) return;
      this.classList.add('wt-drawer-search--active');
      document.body.classList.add('search-overlay-on');
      this.input.setAttribute('aria-expanded', 'true');
      this.input.focus();
      if (this.input.value.trim()) this.load();
    }
    close() {
      this.cancel();
      this.classList.remove('wt-drawer-search--active');
      document.body.classList.remove('search-overlay-on');
      this.input.setAttribute('aria-expanded', 'false');
      this.trigger.focus();
    }
    keyboard(event) {
      if (!this.classList.contains('wt-drawer-search--active')) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      const focusable = [...this.querySelectorAll('input,button,a[href]')]
        .filter(el => !el.disabled && el.getClientRects().length && el !== this.trigger);
      if (event.key === 'Tab') {
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const links = [...this.results.querySelectorAll('a[href],button')].filter(el => el.getClientRects().length);
        if (!links.length) return;
        event.preventDefault();
        const i = links.indexOf(document.activeElement);
        const next = i < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1)
          : (i + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links[next].focus();
      }
    }
    async load() {
      const term = this.input.value.trim();
      if (!term) return;
      this.cancel();
      const requestId = this.requestId;
      this.controller = new AbortController();
      this.setAttribute('loading', '');
      this.top.setAttribute('aria-hidden', 'true');
      this.status.textContent = 'Szukamy kaw…';
      const strict = normalize(term) === config.query;
      const url = strict ? searchUrl(term) : new URL(config.predictiveUrl, location.origin);
      url.searchParams.set('q', normalize(term));
      url.searchParams.set('section_id', strict ? 'dpk-search-suggestions' : 'predictive-search');
      if (!strict) url.searchParams.set('resources[limit]', '6');
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (requestId !== this.requestId || term !== this.input.value.trim()) return;
        const section = doc.querySelector('.shopify-section');
        if (!section) throw new Error('Missing search section');
        this.results.replaceChildren(...section.childNodes);
        this.results.querySelectorAll('[tabindex="-1"]').forEach(el => el.removeAttribute('tabindex'));
        this.results.querySelectorAll('[role="listbox"],[role="option"]').forEach(el => el.removeAttribute('role'));
        this.setAttribute('results', '');
        this.status.textContent = this.results.querySelector('a[href]') ? 'Wyniki wyszukiwania są dostępne.' : 'Brak wyników.';
      } catch (error) {
        if (error.name === 'AbortError' || requestId !== this.requestId) return;
        this.results.replaceChildren();
        const link = document.createElement('a');
        link.className = 'search-result-more__link';
        link.href = searchUrl(term).href;
        link.textContent = 'Zobacz wyniki wyszukiwania';
        this.results.append(link);
        this.setAttribute('results', '');
        this.status.textContent = 'Podpowiedzi są chwilowo niedostępne. Możesz przejść do wyników.';
      } finally {
        if (requestId === this.requestId) this.removeAttribute('loading');
      }
    }
    disconnectedCallback() { this.cancel(); document.body.classList.remove('search-overlay-on'); }
  });
})();
